<div class="app-logout p-4">
    <div class="text-center">
        <p><strong translate>THANK_YOU</strong></p>
        <p translate>SUCCESSFULLY_LOGGED_OUT</p>
    </div>
</div>
